import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrinter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPrinter"><Path d="M17.5 2.5H6.5V6.5H17.5V2.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M6.5 21.5H17.5V13.5H6.5V21.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M21.5 6.5H2.5V17.5H6.5V13.5H17.5V17.5H21.5V6.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M9.5 10.5H6.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPrinter;
